import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * A custom element that shows/hides the free-shipping message when the
 * selected variant changes.
 *
 * The Liquid block decides server-side whether the message qualifies (variant
 * price >= threshold). On variant change this component finds its re-rendered
 * counterpart in the Section Rendering API response carried by the
 * ProductSelectEvent and adopts its hidden state and contents — the same
 * pattern as product-price.js.
 *
 * @extends {Component}
 */
class FreeShippingComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /** @param {import('@shopify/events').ProductSelectEvent} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const updated = detail.html.querySelector(`free-shipping-component[data-block-id="${this.dataset.blockId}"]`);
        if (!updated) return;

        this.toggleAttribute('hidden', updated.hasAttribute('hidden'));
        this.innerHTML = updated.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[free-shipping] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('free-shipping-component')) {
  customElements.define('free-shipping-component', FreeShippingComponent);
}
